/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

import FloraiStoreButtons from './FloraiStoreButtons';

// Download CTA with store badges and the safety disclaimer
export default function FloraiDownload() {
  return (
    <section id="download" className="florai px-4 text-center py-16">
      <Fade direction="up" triggerOnce>
        <div className="max-w-[760px] mx-auto">
          <h2 className="text-[clamp(1.9rem,3.8vw,2.8rem)] leading-tight mb-3.5 tracking-tight !font-semibold text-[#24361B]">
            Take FlorAI to the
            {' '}
            <em className="font-instrument-serif !font-normal text-[1.08em]">forest</em>
          </h2>
          <p className="text-[#4A5C42] max-w-xl mx-auto mb-8 text-[1.05rem]">
            Free download. Scan your first plant in under a minute — no sign-up required.
          </p>
          <FloraiStoreButtons variant="dark" />
          <p className="mt-5 text-[.85rem] text-[#5C6B53]">
            Available in Vietnamese and English · Android 8+ / iOS 15+
          </p>
          <p className="mt-6 text-[.78rem] text-[#4A5C42] opacity-85">
            FlorAI provides species identification and safety information for reference. It flags
            toxic species and dangerous look-alikes, but no AI is a substitute for expert
            verification — never eat a wild mushroom based on an app result alone. If poisoning is
            suspected, seek medical care immediately.
          </p>
        </div>
      </Fade>
    </section>
  );
}
